import React from "react";
import PropTypes from "prop-types";
import { ContinueButton } from "../../../../components/Buttons/ContinueButton";
import { ButtonWrapper } from "./styled";

export const SubmitButton = props => {
  return (
    <ButtonWrapper>
      <ContinueButton type="submit" {...props} />
    </ButtonWrapper>
  );
};

SubmitButton.propTypes = {
  onClick: PropTypes.func,
  disabled: PropTypes.bool
};
